/* eslint-disable import/prefer-default-export */
export const searchTags = [
  {
    title: 'wikipedia',
    icon: 'source-wikipedia',
    tag: 'w',
  },
  {
    title: 'amazon',
    icon: 'source-amazon',
    tag: 'a',
  },
  {
    title: 'youtube',
    icon: 'source-youtube',
    tag: 'yt',
  },
  {
    title: 'google',
    icon: 'source-google',
    tag: 'g',
  },
];
